import { InjectedConnector } from '@web3-react/injected-connector'

const chainId = (process.env.REACT_APP_CHAIN_ID && +process.env.REACT_APP_CHAIN_ID) || 1

export const injected = new InjectedConnector({
  supportedChainIds: [chainId]
})
